// extracted by mini-css-extract-plugin
module.exports = {"title":"FieldEnableCard_title__1Bobb","flexRow":"FieldEnableCard_flexRow__39tv5","flexSpacer":"FieldEnableCard_flexSpacer__3I538"};